module.exports = __webpack_public_path__ + "media/images/upload-cloud-icon-bb2aed80ae3eb54037d463aee55a307d.svg";